import { render, staticRenderFns } from "./CustomerBilling.vue?vue&type=template&id=5b5f39ed&scoped=true&"
import script from "./CustomerBilling.vue?vue&type=script&lang=js&"
export * from "./CustomerBilling.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBilling.vue?vue&type=style&index=0&id=5b5f39ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f39ed",
  null
  
)

export default component.exports